import Vue from "vue";
const Bus = new Vue();
module.exports = Bus;
